import React, { useEffect, useState } from "react";
import { Modal, Typography, Button } from "antd";
import { BellFilled, CloseOutlined } from "@ant-design/icons";
import { API_URL } from "./utils/constants";
import { RootState } from "./store/store";
import { useSelector } from "react-redux";

const { Title, Text } = Typography;

const ReminderEODBODModal: React.FC = () => {
  const { selectedHospital } = useSelector(
    (state: RootState) => state.hospital,
  );
  const { auth } = useSelector((state: RootState) => state);

  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (
      !selectedHospital?.value ||
      (auth?.role?.role !== "Mid Office Role" &&
        auth?.role?.role !== "FO_STAFF")
    )
      return;

    const url = `${API_URL}/api/sse/subscribe/eodbod-notification`;
    const eventSource = new EventSource(url);

    eventSource.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);

        const selectedHospitalDetails = data?.hospitalNotifications?.find(
          (hospital: any) => hospital.hospitalId === selectedHospital.value,
        );

        if (selectedHospitalDetails) {
          setMessage(
            selectedHospitalDetails?.message ||
              "Please complete your BOD / EOD process",
          );

          setVisible(true);
        }
      } catch (error) {
        console.error("Error parsing SSE:", event.data);
      }
    };

    eventSource.onerror = () => eventSource.close();
    return () => eventSource.close();
  }, [selectedHospital]);

  useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => setVisible(false), 30000);
      return () => clearTimeout(timer);
    }
  }, [visible]);

  const handleClose = () => {
    setVisible(false);
  };

  return (
    <Modal
      open={visible}
      footer={null}
      centered
      closable={false}
      width={670}
      bodyStyle={{
        padding: "32px 24px",
        borderRadius: "20px",
        background: "rgba(255,255,255,0.9)",
        backdropFilter: "blur(10px)",
      }}
      style={{ borderRadius: "20px" }}
    >
      <div style={{ position: "relative", textAlign: "center" }}>
        {/* Close Button */}
        <div
          onClick={() => setVisible(false)}
          style={{
            position: "absolute",
            top: -10,
            right: -10,
            width: 32,
            height: 32,
            borderRadius: "50%",
            background: "#fff",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <CloseOutlined style={{ fontSize: 14 }} />
        </div>

        {/* Accent line */}
        <div
          style={{
            height: 4,
            width: 60,
            margin: "0 auto 20px",
            borderRadius: 10,
            background: "linear-gradient(90deg, #faad14, #ffc53d)",
          }}
        />

        {/* Icon */}
        <div
          style={{
            width: 80,
            height: 80,
            margin: "0 auto",
            borderRadius: "50%",
            background: "linear-gradient(135deg, #fff7e6, #ffe58f)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 10px 30px rgba(250, 173, 20, 0.35)",
            animation: "popIn 0.4s ease",
          }}
        >
          <BellFilled style={{ fontSize: 50, color: "#faad14" }} />
        </div>

        {/* Title */}
        <Title
          level={3}
          style={{
            marginTop: 20,
            marginBottom: 6,
            fontWeight: 600,
            letterSpacing: "0.3px",
          }}
        >
          Reminder Alert
        </Title>

        {/* Divider */}
        <div
          style={{
            width: 40,
            height: 2,
            background: "#f0f0f0",
            margin: "10px auto",
            borderRadius: 10,
          }}
        />

        {/* Message */}
        <div
          style={{
            marginTop: 20,
            padding: "18px 20px",
            borderRadius: 16,
            background: "linear-gradient(145deg, #f8fafc, #f1f5f9)",
            boxShadow: "inset 0 1px 2px rgba(0,0,0,0.05)",
            border: "1px solid #e5e7eb",
          }}
        >
          <Text
            style={{
              fontSize: 16,
              color: "#374151",
              lineHeight: 1.8,
              display: "block",
              whiteSpace: "pre-line",
              fontWeight: 500,
              letterSpacing: "0.2px",
            }}
          >
            {message}
          </Text>
        </div>
      </div>

      {/* Animation */}
      <style>
        {`
          @keyframes popIn {
            0% {
              transform: scale(0.8);
              opacity: 0;
            }
            100% {
              transform: scale(1);
              opacity: 1;
            }
          }
        `}
      </style>
    </Modal>
  );
};

export default ReminderEODBODModal;
